import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

const PrivateRoute = ({ Component }) => {
  const { userData } = useAuth();
  return userData ? <Component/> : <Navigate to="/"/>  ;
};

export default PrivateRoute;